export enum Markets {
  'USA' = 'usa',
  'Armenia' = 'am',
  Japan = 'jp',
  Russia = 'ru',
  UnitedKingdom = 'uk',
}
